import { clampHue } from '../tag-color-utils'

interface Props {
  hue: number
  onChange(hue: number): void
}

/**
 * Horizontal hue slider (0–360°). Pointer capture lets users drag past the
 * slider edges, clamped via {@link clampHue}.
 */
export const HueSlider: React.FC<Props> = ({ hue, onChange }) => {
  function handlePointer(evt: React.PointerEvent<HTMLDivElement>) {
    if (evt.buttons !== 1 && evt.type !== 'pointerdown') return
    const rect = evt.currentTarget.getBoundingClientRect()
    const nh = clampHue(((evt.clientX - rect.left) / rect.width) * 360)
    onChange(nh)
  }

  return (
    <div
      className="relative h-3 w-full rounded-full cursor-pointer touch-none"
      style={{
        background:
          'linear-gradient(to right, #f00, #ff0, #0f0, #0ff, #00f, #f0f, #f00)',
      }}
      onPointerDown={evt => {
        evt.currentTarget.setPointerCapture(evt.pointerId)
        handlePointer(evt)
      }}
      onPointerMove={handlePointer}
    >
      <div
        className="absolute top-1/2 size-4 -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-white shadow"
        style={{ left: `${(hue / 360) * 100}%` }}
      />
    </div>
  )
}
